import * as moment from "moment";
import iBroadcast from "@/interfaces/channels/broadcast";

export default abstract class Broadcast<T> implements iBroadcast<T> {
  /**
   * When the broadcast was broadcasted.
   */
  public readonly broadcastAt: moment.Moment = moment();

  /**
   * The broadcast's data.
   */
  public readonly data: T;

  /**
   * @param data The broadcasted data.
   */
  public constructor(data: T) {
    this.data = data;
  }
}
